export default "__VITE_ASSET__BPwZK$xM__"